import { useEffect, useState } from 'react';
import { navChannels } from '@/mocks/gossip';

const channelAnchor: Record<string, string> = {
  new: '#latest',
  hammer: '#hammer',
  audio: '#audio',
  chat: '#chat',
  rank: '#rank',
  zone: '#zone',
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const announce = () => {
    setToast(true);
    window.setTimeout(() => setToast(false), 2600);
  };

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-paper-50/95 backdrop-blur border-b border-paper-200' : 'bg-paper-50 border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:px-6 lg:px-8">
        {/* logo */}
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-flame-500 text-white">
            <i className="ri-flashlight-line text-lg" />
          </span>
          <span className="leading-none">
            <span className="block font-display text-lg font-black tracking-tight text-ink-950">明星黑料</span>
            <span className="mt-1 block text-[10px] font-bold tracking-[0.28em] text-flame-600">证据整理·实锤现场</span>
          </span>
        </a>

        {/* center nav */}
        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {navChannels.map((c) => (
            <a
              key={c.key}
              href={channelAnchor[c.key] ?? '#latest'}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-semibold text-ink-700 transition-colors hover:bg-paper-100 hover:text-ink-950"
            >
              {c.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          {/* search */}
          <label className="hidden items-center gap-2 rounded-full border border-paper-200 bg-paper-50 px-3.5 py-2 text-sm text-ink-600 focus-within:border-ink-900 md:flex">
            <i className="ri-search-line text-base" />
            <input
              type="text"
              placeholder="搜明星 / 事件 / 话题"
              className="w-32 bg-transparent outline-none lg:w-44"
            />
          </label>
          <button
            type="button"
            onClick={announce}
            className="hidden cursor-pointer whitespace-nowrap rounded-full bg-flame-500 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-flame-600 sm:inline-flex"
          >
            <i className="ri-megaphone-line mr-1.5 text-base" />
            我要爆料
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen(true)}
            className="grid h-10 w-10 cursor-pointer place-items-center rounded-full text-ink-800 hover:bg-paper-100 lg:hidden"
          >
            <i className="ri-menu-line text-xl" />
          </button>
        </div>
      </div>

      {/* mobile drawer */}
      {open ? (
        <div className="fixed inset-0 z-[60] lg:hidden">
          <div className="absolute inset-0 bg-ink-950/40" onClick={() => setOpen(false)} />
          <div className="absolute inset-y-0 right-0 flex w-72 max-w-[85vw] flex-col bg-paper-50 px-5 py-4">
            <div className="flex items-center justify-between">
              <span className="font-display text-lg font-black text-ink-950">明星黑料</span>
              <button
                type="button"
                aria-label="关闭"
                onClick={() => setOpen(false)}
                className="grid h-9 w-9 cursor-pointer place-items-center rounded-full bg-paper-100 text-ink-800"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <nav className="mt-6 flex flex-col gap-1">
              {navChannels.map((c) => (
                <a
                  key={c.key}
                  href={channelAnchor[c.key] ?? '#latest'}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-lg px-3 py-3 text-base font-bold text-ink-900 hover:bg-paper-100"
                >
                  {c.label}
                  <i className="ri-arrow-right-line text-ink-400" />
                </a>
              ))}
            </nav>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                announce();
              }}
              className="mt-6 cursor-pointer rounded-full bg-flame-500 px-4 py-3 text-sm font-bold text-white"
            >
              <i className="ri-megaphone-line mr-1.5" />
              我要爆料
            </button>
          </div>
        </div>
      ) : null}

      {/* toast */}
      {toast ? (
        <div className="fixed bottom-6 left-1/2 z-[70] -translate-x-1/2">
          <div className="flex items-center gap-2 rounded-full bg-ink-950 px-5 py-3 text-sm font-semibold text-paper-50">
            <i className="ri-check-double-line text-flame-400" />
            爆料线索已收录，进入人工审核（演示）
          </div>
        </div>
      ) : null}
    </header>
  );
}